import { api } from '@/lib/api/client';

/** sreg-api's record of a chat session (P1-C3). */
export interface AgentSession {
  id: string;
  agentName: string;
  vertexSessionId: string;
  userId: string;
  title?: string;
  /** First user message, trimmed to 250 characters by sreg-api. */
  firstUserMessage?: string;
  lastActivityAt?: string;
  /** Hidden from the owner's list; kept for ops review. There is no delete. */
  archivedAt?: string;
  createdAt: string;
}

export const SESSION_PAGE_SIZE = 10;

export function listMySessions(
  opts: { archived: boolean; limit: number; offset?: number },
  signal?: AbortSignal,
): Promise<AgentSession[]> {
  return api.get<AgentSession[]>(
    '/agent-sessions',
    { archived: opts.archived, limit: opts.limit, offset: opts.offset ?? 0 },
    signal,
  );
}

export function getSession(vertexSessionId: string, signal?: AbortSignal): Promise<AgentSession> {
  return api.get<AgentSession>(`/agent-sessions/${encodeURIComponent(vertexSessionId)}`, undefined, signal);
}

/** Set or clear a session's title (sreg-api trims to 250 characters; empty clears). */
export function setSessionTitle(vertexSessionId: string, title: string): Promise<AgentSession> {
  return api.patch<AgentSession>(`/agent-sessions/${encodeURIComponent(vertexSessionId)}`, { title });
}

export function setSessionArchived(vertexSessionId: string, archived: boolean): Promise<AgentSession> {
  return api.patch<AgentSession>(`/agent-sessions/${encodeURIComponent(vertexSessionId)}`, { archived });
}

/** What a session is called in the list: its title, else the first message preview. */
export function sessionLabel(s: Pick<AgentSession, 'title' | 'firstUserMessage'>): string {
  return s.title || s.firstUserMessage || 'New conversation';
}
